import { forwardRef } from "react";
import { Icon, type IconProps } from "../Icon";

export const Snapchat = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <Icon ref={ref} {...props}>
      <path d="M12 2C9.6 2 8 4.4 8 6.7c0 1.2.2 2.3.7 3.3-.6.1-1.2.2-1.7.2s-.9-.1-1.2-.4c-.2-.2-.3-.4-.3-.7s.1-.5.3-.7.5-.3.8-.3h.2l.3-.1c.1-.1.2-.2.2-.3s-.1-.3-.2-.4c-.3-.2-.6-.3-1-.3-.5 0-.9.2-1.3.5-.3.3-.5.8-.5 1.3s.2 1 .5 1.3q.6.6 1.5.6c.8 0 1.5-.2 2.2-.5.5 1 1.3 1.8 2.2 2.3-.1.5-.2 1-.2 1.5 0 1.5.6 2.8 1.6 3.8s2.3 1.6 3.8 1.6 2.8-.6 3.8-1.6 1.6-2.3 1.6-3.8c0-.5-.1-1-.2-1.5.9-.5 1.7-1.3 2.2-2.3.7.3 1.4.5 2.2.5q.9 0 1.5-.6c.3-.3.5-.8.5-1.3s-.2-1-.5-1.3c-.4-.3-.8-.5-1.3-.5-.4 0-.7.1-1 .3-.1.1-.2.3-.2.4s.1.2.2.3l.3.1h.2c.3 0 .6.1.8.3s.3.4.3.7-.1.5-.3.7c-.3.3-.7.4-1.2.4s-1.1-.1-1.7-.2c.5-1 .7-2.1.7-3.3C16 4.4 14.4 2 12 2" />
    </Icon>
  );
});

Snapchat.displayName = "Snapchat";
